import Link from "next/link";
import React from "react";
import ButtonV2 from "../../elements/Base/ButtonV2";
import ClearFilters from "./ClearFilters";
import FilterBlock from "./FilterBlock/FilterBlock";

const Filters = (props) => {
    let hasFilters = false;

    for(let i in props.filters) {
        if(props.filters[i].textId === "categories") {
            continue;
        }

        if(hasFilters === true) {
            break;
        }

        let counts = props.filters[i].counts;
        for(let j in counts) {
            if(counts[j].status === true) {
                hasFilters = true;
                break;
            }
        }
    }

    return (
        <div className="filters-wrapper">
            <style jsx>{`
                .filters-wrapper {
                    padding-bottom: 50px;
                }

                .padding-wrapper {
                    margin-left: 10px;
                    margin-right: 10px;
                }
            `}</style>
            {props.filters.map(filter => {
                if(filter.textId === 'categories' && (props.view === 'singles' || props.view === 'singles-search')) {
                    if(props.view === 'singles-search') {
                        return <div className="padding-wrapper">
                            <Link href="/singles">
                                <ButtonV2 type='dark-reverse'>Vezi toate cartile</ButtonV2>
                            </Link>
                        </div>
                    }

                    return;
                }


                return (
                    filter.textId === 'categories' ?
                    <>
                        <div className="padding-wrapper">
                            <Link href="/toate-produsele">
                                <ButtonV2 type='blue'>VEZI TOATE PRODUSELE</ButtonV2>
                            </Link>
                        </div>
                        <FilterBlock
                            view={props.view}
                            enabled={props.enabled}
                            key={filter.textId}
                            id={filter.textId}
                            title={filter.name}
                            type="categories"
                            options={filter.counts.map(count => ({
                                key: count.value,
                                label: `${count.label} ${filter.countable && count.count !== null ? `(${count.count})` : ``}`,
                                status: count.status,
                                depth: count.depth,
                                textId: 'categories'
                            }))}
                            onChange={props.onChange}
                        />
                        {hasFilters? <ClearFilters clearFilters={props.clearFilters}/> : null}
                    </> :
                        <FilterBlock
                            enabled={props.enabled}
                            key={filter.textId}
                            id={filter.textId}
                            title={filter.name}
                            type="checkbox"
                            options={filter.counts.filter(count => (count.count > 0 && count.label.trim() !== "") || count.status).map(count => ({
                                count: count.count,
                                key: count.value,
                                label: `${count.label} ${filter.countable ? `(${count.count})` : ``}`,
                                status: count.status,
                                position: count.position || 0,
                                type: filter.type
                            }))}
                            onChange={props.onChange}
                        />
                )
            })}
        </div>
    )
}

export default Filters;
